import React from 'react'
import { Oval } from 'react-loader-spinner'

function Button({ icon, color, fullWidth = false, fullRound = false, loading = false, children, ...rest }) {

    let bg = "bg-slate-900"
    let text = "text-white"

    if (color === "primary") {
        bg = "bg-[#7565db]"
    } else if (color === "red") {
        bg = "bg-[#e33636]"
    } else if (color === "secondary") {
        bg = "bg-[#e33636]"
        text = "text-[#7565db]"
    } else if (color === "white") {
        bg = "bg-white"
        text = "text-gray-400"
    }
    else {
        bg = "bg-slate-900"
    }

    return (
        <button
            {...rest}
            style={{ opacity: loading ? "0.7" : '1' }}
            disabled={loading}
            className={`px-8 py-2.5 ${bg} ${fullRound ? "rounded-full" : 'rounded-lg'} 
            ${text} text-sm ${loading ? "cursor-not-allowed " : null}
            ${fullWidth ? "w-full" : null} flex justify-center items-center gap-2
                `}
        >
            {icon && !loading && (
                <div>{icon}</div>
            )}

            {loading && (
                <Oval
                    width={15}
                    height={15}
                    strokeWidth={6}
                    color='white'
                    secondaryColor='white'
                />
            )}
            {children}
        </button>
    )
}

export default Button